import { Select } from 'antd'
import { FC } from 'react'

const Option = Select.Option

export const KeywordSelector: FC<{ kwList, setKwSearch, placeholder, mode, value?, onChange? }> = ({ kwList, setKwSearch, placeholder, mode, value, onChange }) =>
    <Select
        allowClear
        showSearch
        value={value}
        onChange={onChange}
        filterOption={false}
        onSearch={setKwSearch}
        placeholder={placeholder}
        mode={mode}
    >
        {kwList.map((item: string) => <Option key={item} value={item}>{item}</Option>)}
    </Select>
